export const encodings = {
    state: {
        encodingList: []
    },
    getters: {
        getEncodingData: state => {
            return state.encodingList;
        }
    },
    mutations: {
        setEncodingList: (state, val) => {
            state.encodingList = val;
        }
    },
    actions: {
        listEncodingList(context, data) {
            let myHeaders = new Headers();
            let logininfo = localStorage.getItem("token") ?
                localStorage.getItem("token") :
                "";
            myHeaders.append("Authorization", `Bearer ${logininfo}`);
            let requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            return new Promise((resolve, reject) => {
                fetch(
                        `${context.getters.getbaseUrl}provider/v1/encodings?encodingid=${data.encodingid}&encodingtype=${data.encodingtype}&codec=${data.codec}&quality=${data.quality}&presetid=${data.presetid}&updatedon=${data.updatedon}&page=${data.page}&pagesize=${data.pagesize}`,
                        requestOptions
                    )
                    .then(response => {
                        if (response.ok) {
                            resolve(response.json());
                        } else {
                            reject(response);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        createEncoding(context, data) {
            let myHeaders = new Headers();
            let logininfo = localStorage.getItem("token") ?
                localStorage.getItem("token") :
                "";
            myHeaders.append("Authorization", `Bearer ${logininfo}`);
            let requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: data,
                redirect: "follow"
            };
            return new Promise((resolve, reject) => {
                fetch(
                        `${context.getters.getbaseUrl}provider/v1/encodings`,
                        requestOptions
                    )
                    .then(response => {
                        if (response.ok) {
                            resolve(response.json());
                        } else {
                            resolve(response.json());
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        deleteEncoding(context, data) {
            let myHeaders = new Headers();
            let logininfo = localStorage.getItem("token") ?
                localStorage.getItem("token") :
                "";
            myHeaders.append("Authorization", `Bearer ${logininfo}`);
            let requestOptions = {
                method: "DELETE",
                headers: myHeaders,
                redirect: "follow"
            };
            return new Promise((resolve, reject) => {
                fetch(
                        `${context.getters.getbaseUrl}provider/v1/encodings/${data.encodingid}`,
                        requestOptions
                    )
                    .then(response => {
                        if (response.ok) {
                            resolve(response.json());
                        } else {
                            resolve(response.json());
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
        //   addProfileList (context, data) {
        //     let myHeaders = new Headers()
        //     let logininfo = localStorage.getItem('token') ? localStorage.getItem('token') : ''
        //     myHeaders.append('Authorization', `Bearer ${logininfo}`)
        //     let formdata = new FormData()
        //     formdata.append('profileid', data.profileid)
        //     if (data.profiletype) {
        //       formdata.append("profiletype", data.profiletype)
        //     }
        //     formdata.append('encoding', JSON.stringify(data.encoding))
        //     if (data.watermarkdetails) {
        //       formdata.append('watermarkdetails', JSON.stringify(data.watermarkdetails))
        //     }
        //     if (data.trailerdetails) {
        //       formdata.append('trailerdetails', JSON.stringify(data.trailerdetails))
        //     }
        //     if (data.posterdetails) {
        //       formdata.append('posterdetails', JSON.stringify(data.posterdetails))
        //     }
        //     return new Promise((resolve, reject) => {
        //       fetch(`${context.getters.getbaseUrl}provider/v1/transcodeprofile`, {
        //         method: 'POST',
        //         headers: myHeaders,
        //         body: formdata,
        //         redirect: 'follow'
        //       })
        //         .then((response) => {
        //           if (response.ok) {
        //             resolve(response.json())
        //           } else {
        //             reject(response)
        //           }
        //         }).catch(error => {
        //           reject(error)
        //         })
        //     })
        //   },
        //   updateProfileList (context, data) {
        //     let myHeaders = new Headers()
        //     let logininfo = localStorage.getItem('token') ? localStorage.getItem('token') : ''
        //     myHeaders.append('Authorization', `Bearer ${logininfo}`)
        //     myHeaders.append('Content-Type', 'application/json')
        //     let raw = JSON.stringify(data.bodyData)
        //     console.log(raw)
        //     return new Promise((resolve, reject) => {
        //       fetch(`${context.getters.getbaseUrl}provider/v1/transcodeprofile/${data.id}`, {
        //         method: 'PUT',
        //         headers: myHeaders,
        //         body: raw,
        //         redirect: 'follow'
        //       })
        //         .then((response) => {
        //           if (response.ok) {
        //             resolve(response.json())
        //           } else {
        //             reject(response)
        //           }
        //         }).catch(error => {
        //           reject(error)
        //         })
        //     })
        //   }
    }
};


// WEBPACK FOOTER //
// ./src/store/encoding.js